// Backend contract: /api/v2/settings?types=integration returns the account
// integration row as settings.integration.
export const isIdentityVerificationEnabled = (settings = {}) =>
  settings?.integration?.identity_verification_enabled === true;
